import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appOverflowTooltip]'
})
export class OverflowTooltipDirective implements AfterViewInit {
  domElement: HTMLElement;

  constructor(private elementRef: ElementRef, 
            private renderer: Renderer2) {
    }

    ngAfterViewInit(): void {
      this.domElement = this.elementRef.nativeElement;
      this.setToolTip();
    }

    @HostListener("window:resize", ["$event.target"])
    setToolTip(): void {
      (this.domElement.offsetHeight < this.domElement.scrollHeight) ?
          (this.renderer.addClass(this.domElement, 'isTooltipActive'),
          this.renderer.setAttribute(this.domElement, 'tabindex', '0')) :
          this.renderer.removeClass(this.domElement, 'isTooltipActive');
    }

}
